var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    id: "add-photo-medium",
    "data-supported-dps": "56x56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h56v56H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8 25h40v17H8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#00a0dc",
    d: "M54 6h-4V2h-3v4h-4v3h4v4h3V9h4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#9bdaf3",
    d: "M38.625 17l-2.25-5h-16.75l-2.25 5H8v7h40v-7z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#005e93",
    d: "M9 23h38v3H9z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28 37c-4.962 0-9-4.037-9-9s4.038-9 9-9 9 4.037 9 9-4.038 9-9 9z",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28 19.875c4.48 0 8.125 3.645 8.125 8.125S32.48 36.125 28 36.125 19.875 32.48 19.875 28 23.52 19.875 28 19.875M28 17c-6.075 0-11 4.925-11 11s4.925 11 11 11 11-4.925 11-11-4.925-11-11-11z",
    fill: "#005e93"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M28 22a6 6 0 100 12 6 6 0 000-12z",
    fill: "#00a0dc"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M35.625 13l2.24 5H47v23H9V18h9.132l2.243-5h15.213m-15.872-3a2 2 0 00-1.834 1.202L16.165 15H8a2 2 0 00-2 2v25a2 2 0 002 2h40a2 2 0 002-2V17a2 2 0 00-2-2h-8.168l-1.717-3.798A2 2 0 0036.281 10H19.716z",
    fill: "#005e93"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoto);
export default __webpack_public_path__ + "static/media/photo.b826ffee63cd7ef528688a4fd807b1a1.svg";
export { ForwardRef as ReactComponent };